import styled from 'styled-components';

export const Grid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 5rem);
  background: #f7f7f7;
  padding: 40px 20px;
`;

export const AuthSection = styled.div`
  background-color: #ffffff;
  max-width: 568px;
  width: 100%;
  padding: 48px;
  border-radius: 12px;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.12),
    0 4px 16px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 32px 24px;
    margin: 0;
  }
`;

export const AuthTitle = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: #000000;
  margin: 0 0 32px 0;
  letter-spacing: -0.02em;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 26px;
    margin-bottom: 24px;
  }
`;
